import ArticleBody from './articleBody'

const articleBody = new ArticleBody()
articleBody.init()
